import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";

export const exporter = (data) => {
  console.log("sectors list data ...", data[0]);

  const dataForExport = data.map(({ name, lab, representative, type }) => ({
    ID: name || "",
    Laboratório: lab ? lab.name : "",
    Representante: representative || "",
    "Tipo de Documento": type || "",
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["ID", "Laboratório", "Representante", "Tipo de Documento"], // order fields in the export
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "sectors"); // download as 'posts.csv` file
};

export const sectorsUsersExport = (data) => {
  console.log("data", data);
  const { name, representative, sectorsUsers } = data;

  const validSectorsUsers = sectorsUsers.filter(
    (sectorUser) =>
      sectorUser.user !== undefined &&
      sectorUser.user !== null &&
      sectorUser.owner === false
  );
  const exportData = validSectorsUsers.map((sectorUser) => ({
    Representante: representative,
    ID: sectorUser.user.id || "",
    Setor: name || "",
    "Tipo de Documento": sectorUser.user.typeUser
      ? sectorUser.user.typeUser.name || ""
      : "",
    Documento: sectorUser.user.document || "",
    Nome: `${sectorUser.user.name || ""} ${sectorUser.user.lastName || ""}` || "",
    CPF: sectorUser.user.cpf || "",
    Email: sectorUser.user.email || "",
    Telefone: sectorUser.user.phone || sectorUser.user.cellPhone || "",
  }));

  const csv = convertToCSV(
    {
      data: exportData,
      fields: [
        "Representante",
        "ID",
        "Setor",
        "Tipo de Documento",
        "Documento",
        "Nome",
        "CPF",
        "Email",
        "Telefone",
      ], // order fields in the export
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "sectorsUsers"); // download as 'posts.csv` file
};

export const representativeExport = (data) => {
  const { name, representative, sectorsUsers } = data;

  const validSectorsUsers = sectorsUsers.filter(
    (sectorUser) => sectorUser.user !== undefined && sectorUser.user !== null
  );
  // .filter(sectorUser => sectorUser.user.roleUserId === 1);

  const exportData = validSectorsUsers.map((sectorUser) => ({
    Representante: representative,
    ID: sectorUser.user.id || "",
    Setor: name || "",
    Nome: `${sectorUser.user.name || ""} ${sectorUser.user.lastName || ""}` || "",
    Email: sectorUser.user.email || "",
  }));

const csv = convertToCSV(
    {
      data: exportData,
      fields: ["Representante", "ID", "Setor", "Nome", "Email"], // order fields in the export
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "representatives"); // download as 'posts.csv` file
};
